/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {

  'use strict';

  app.CartDiscountMixin = {
    /**
     * Аггрегируем данные об акциях из ответа.
     * @param resp
     * @returns {{sum: number, discounts: Array}}
     */
    getDiscountData: function (resp) {
      // Типы скидок
      var discountTypes = ['_volume_discount', '_wholesale', '_gifts_discount', '_3_price_2_discount', 'large_family'],
        discountData = {
          sum: 0,
          discounts: []
        },
        discounts;
      discountTypes.forEach(function (type) {
        if (resp[type] && resp[type].discounts) {
          discountData.sum += resp[type].sum;
          discounts = resp[type].discounts.map(function (discount) {
            discount.type = type;
            return discount;
          });
          discountData.discounts = discountData.discounts.concat(discounts);
        }
      });
      var threeByTwoDiscountSum = resp['_3_price_2_discount'];
      if (threeByTwoDiscountSum) {
        discountData.threeByTwoDiscountSum = threeByTwoDiscountSum.sum;
      }
      return discountData;
    }
  };
})();

}.call(window));